<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" background-color="#FFFFFF" color="#005f32"
      spinner="bar-fade-scale" />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12>
        <v-card-title class="elevation-0">
          <span class="itemHeading">Download Folder</span>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 md2>
            <v-btn style="font-family: kumbhMedium" block color="#005f32" dark class="rounded-xl"
              @click="addFilesDialog = true">
              ADD FILES
            </v-btn>
          </v-flex>
        </v-card-title>
        <!-- Add existing files listing here if needed -->
        <v-layout wrap v-if="files && files.length > 0">
          <v-flex xs12 pa-4>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">File Name</th>
                    <th class="text-left">View</th>
                    <th class="text-left">Delete</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(file, i) in files" :key="i">
                    <td class="text-left">{{ getFileName(file.title) }}</td>
                    <td class="text-left">
                      <v-btn small icon color="primary" @click="previewFile(file)">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </td>
                    <td class="text-left">
                      <v-btn small icon color="red" @click="deleteFile(file._id)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>
        <v-layout wrap v-else>
          <v-flex xs12 text-center pa-4>
            <span>No files uploaded yet.</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Add Files Dialog -->
    <v-dialog v-model="addFilesDialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Add Files</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="fileDescription" label="File Name" outlined dense></v-text-field>
          <v-file-input v-model="selectedFile" label="Select File" outlined dense accept="*/*"
            :rules="[rules.required]"></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text
            @click="addFilesDialog = false; selectedFile = null; fileDescription = ''">Close</v-btn>
          <v-btn color="blue darken-1" text :disabled="!selectedFile" @click="uploadFile">Upload</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="previewDialog" max-width="900px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ previewTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-img v-if="previewType === 'image'" :src="previewUrl" contain max-height="70vh"></v-img>
          <video v-else-if="previewType === 'video'" :src="previewUrl" controls
            style="width: 100%; max-height: 70vh;"></video>
          <audio v-else-if="previewType === 'audio'" :src="previewUrl" controls style="width: 100%;"></audio>
          <iframe v-else-if="previewType === 'pdf' || previewType === 'office'" :src="previewUrl"
            style="width:100%; height:70vh;" frameborder="0"></iframe>
          <div v-else style="padding: 16px;">This file type cannot be previewed here.</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="downloadCurrent">Open in new tab</v-btn>
          <v-btn color="blue darken-1" text @click="previewDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      msg: null,
      folder: null,
      files: [],
      addFilesDialog: false,
      selectedFile: null,
      fileDescription: '',
      rules: {
        required: (value) => !!value || "Required.",
      },
      formData: new FormData(),
      previewDialog: false,
      previewUrl: '',
      previewType: '',
      previewTitle: '',
      currentFileUrl: '',
    };
  },
  mounted() {
    // this.getFolder();
    this.getFiles();
  },
  methods: {
    // getFolder() {
    //   const id = this.$route.query.id;
    //   if (!id) {
    //     this.msg = "No folder ID provided";
    //     this.showsnackbar = true;
    //     return;
    //   }
    //   this.appLoading = true;
    //   axios({
    //     url: `/download/category/view/${id}`,
    //     method: "GET",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //   })
    //     .then((response) => {
    //       this.appLoading = false;
    //       if (response.data.status) {
    //         this.folder = response.data.data;
    //       } else {
    //         this.msg = response.data.msg;
    //         this.showsnackbar = true;
    //       }
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       console.log(err);
    //     });
    // },
    getFiles() {
      const id = this.$route.query.id;
      this.appLoading = true;
      axios({
        url: "download/list/",
        method: "GET",
        params: { category: id },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.files = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    uploadFile() {
      if (!this.fileDescription) {
        this.msg = "File name is required";
        this.showsnackbar = true;
        return;
      }
      if (!this.selectedFile) {
        this.msg = "File is required";
        this.showsnackbar = true;
        return;
      }
      const id = this.$route.query.id;
      this.formData.append("file", this.selectedFile);
      this.formData.append("category", id);
      if (this.fileDescription) {
        this.formData.append("title", this.fileDescription);
      }
      this.appLoading = true;
      axios({
        url: `/download/add`,
        method: "POST",
        data: this.formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "File uploaded successfully";
            this.showsnackbar = true;
            this.addFilesDialog = false;
            this.selectedFile = null;
            this.fileDescription = '';
            this.formData = new FormData();
            this.getFiles();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getFileName(url) {
      if (!url) return '';
      return decodeURIComponent(url.split('/').pop());
    },
    previewFile(file) {
      const url = `${this.mediaURL}${file.file}`;
      this.currentFileUrl = url;
      const ext = this.getFileExt(file.file);
      const name = this.getFileName(file.title || file.file);
      this.previewTitle = name;
      const images = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'ico', 'heic', 'heif'];
      const videos = ['mp4', 'webm', 'ogg', 'ogv', 'mov', 'avi', 'mkv', 'wmv', 'm4v'];
      const audios = ['mp3', 'wav', 'ogg', 'aac', 'm4a', 'flac'];
      if (images.includes(ext)) { this.previewType = 'image'; this.previewUrl = url; this.previewDialog = true; return; }
      if (videos.includes(ext)) { this.previewType = 'video'; this.previewUrl = url; this.previewDialog = true; return; }
      if (audios.includes(ext)) { this.previewType = 'audio'; this.previewUrl = url; this.previewDialog = true; return; }
      if (ext === 'pdf') { this.previewType = 'pdf'; this.previewUrl = url; this.previewDialog = true; return; }
      const office = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
      if (office.includes(ext)) { this.previewType = 'office'; this.previewUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`; this.previewDialog = true; return; }
      const gview = ['txt', 'csv', 'rtf', 'odt', 'ods', 'odp'];
      if (gview.includes(ext)) { this.previewType = 'office'; this.previewUrl = `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`; this.previewDialog = true; return; }
      this.openFile(file.file);
    },
    getFileExt(path) {
      const clean = (path || '').split('?')[0];
      const parts = clean.split('.');
      return parts.length > 1 ? parts.pop().toLowerCase() : '';
    },
    downloadCurrent() {
      if (this.currentFileUrl) {
        window.open(this.currentFileUrl, '_blank');
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    deleteFile(id) {
      this.appLoading = true;
      axios({
        url: `/download/delete`,
        method: "POST",
        data: { id },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "File deleted successfully";
            this.showsnackbar = true;
            this.getFiles();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
/* Add any necessary styles */
</style>